var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitbucketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "502px",
    height: "451px",
    viewBox: "0 0 502 451",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bitbucket-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "108.63338%",
    y1: "30.1117195%",
    x2: "46.9265964%",
    y2: "65.8174868%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bitbucket-icon",
    transform: "translate(0.989747, 0.030759)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0307594,0.0399979141 C12.2980178,-0.0197078253 7.7805119,2.01515979 4.69006039,5.60008355 C1.59960887,9.18500731 0.252557869,13.9530257 1.01025312,18.6251202 L69.0173021,431.473566 C70.7663417,441.902077 79.7507725,449.569242 90.3245755,449.658186 L416.582185,449.658186 C424.518628,449.758988 431.333413,444.034569 432.602691,436.199616 L500.60974,18.7052227 C501.367436,14.0331282 500.020385,9.26510984 496.929933,5.68018608 C493.839482,2.09526232 489.321976,0.0603947059 484.589234,0.121435437 L17.0307594,0.0399979141 Z M303.397309,298.423262 L199.264018,298.423262 L171.067927,151.114707 L328.629606,151.114707 L303.397309,298.423262 Z",
    id: "Shape",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.982057,151.114707 L328.629606,151.114707 L303.397309,298.423262 L199.264018,298.423262 L76.3066325,444.370074 C80.2038383,447.740008 85.172602,449.613942 90.3245755,449.658186 L416.662288,449.658186 C424.598731,449.758988 431.413515,444.034569 432.682794,436.199616 L478.982057,151.114707 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucketIcon);
export default __webpack_public_path__ + "static/media/bitbucket-icon.7ca23c93964da2aa1a2b07f1cd57fd43.svg";
export { ForwardRef as ReactComponent };